/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowRockClimbingAdventureTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowRockClimbingAdventure,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Scale New Heights!",
    "Climbing Adventure Awaits!",
    "Rock On!",
  ],
  title: "Rock Climbing Adventure",
  description: "Organize an exciting rock climbing adventure.",
  longDescription:
    "Gather your friends for a thrilling rock climbing experience! Choose a date, decide on the climbing location, and plan gear needed for the trip!",
  emoji: "🧗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Rock Climbing Adventure",
          emoji: "🧗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go rock climbing?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the climbing location?",
            description: "Where do we want to go rock climbing?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What location should we choose?",
                emoji: "🏔",
                completeAction: {
                  question: "Decide on gear needed?",
                  description: "What gear should we prepare for climbing?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What gear should we bring?",
                      emoji: "🎒",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Climb to New Heights!",
    outroDescription:
      "Your rock climbing adventure plans are set! Enjoy the thrill!",
  },
};
